import axiosHelper from "../axiosHelper";

export default class JobGroupsApiHelper {

	async getRelatedJobIdsAsync(jwt: string, groupId: number): Promise<Array<number> | null> {
		try {
			const jobCategoriesHttpClient = axiosHelper.createInstance(jwt);
			const jobCategoriesResponse = await jobCategoriesHttpClient.get(`/api/servicejobgroups/rels/${groupId}`);
			return jobCategoriesResponse.data.map((_: number) => _);
		} catch (e) {			
			console.error(`Error checking category #${groupId} for related jobs`, e);
			return null;
		}
	}
}